import { supabase } from "../components/SupabaseClient";

export const isValidEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim().toLowerCase());

export const runPasswordRules = (password) => [
  {
    valid: password.length >= 8,
    message: "Password must contain at least 8 characters.",
  },
  {
    valid: /\d/.test(password),
    message: "Password must contain at least one digit.",
  },
  {
    valid: /[a-zA-Z]/.test(password),
    message: "Password must contain at least one letter.",
  },
];

export async function checkUserExists(email) {
  try {
    const { data, error } = await supabase.rpc("check_user_exists", {
      email_input: email.trim().toLowerCase(),
    });

    if (error) {
      console.error("Error checking user existence:", error);
      return { exists: false, error };
    }

    return { exists: data === true, error: null };
  } catch (error) {
    console.error("Error checking user existence:", error);
    return { exists: false, error };
  }
}
